import { IsiSubMenuManager } from "./IsiSubMenuManager";

export class IsiMainMenuManager {

    _managers: IsiSubMenuManager[];

    constructor() {
        this._managers = [];
    }

    get managers() {
        return this._managers;
    }

    dispose() {
        for (var elem in this._managers) {
            if (typeof this._managers[elem] != "function") {
                this._managers[elem].dispose();
            }
        }
    }

}